import { syncService } from "Apis";

export const listUtmEntities = async (projectId, syncId) => {
  const res = await syncService.syncServiceListUTMEntities({
    projectId,
    syncId,
  });
  return res.results || [];
};


export const refreshFacebookEntities = async (projectId: number, syncId: number) => {
  return await syncService.syncServiceRefreshFacebookEntities({
    projectId,
    syncId,
  });
};